import { percentage } from '../formatters';

const labelCallback = context => {
    const yLabel = context.parsed.y;
    const label = context.dataset.label;
    const value = percentage(yLabel);
    const formattedLabel = `${label}: ${value}`;
    return formattedLabel;
};

const percentageConfig = () => {
    return {
        scales: {
            y: {
                beginAtZero: true,
                type: 'linear',
                id: 'y-axis-1',
                ticks: {
                    callback: percentage,
                },
            },
        },
        plugins: {
            tooltip: {
                callbacks: {
                    label: labelCallback,
                },
            },
        },
    };
};

export default percentageConfig;
